import httpAuth from "../../services/httpAuth";
import httpNotAuth from "../../services/httpNotAuth";
import { getMenuError, getMenuSuccess } from "./menu.slice";

export const requestMenu = (data) => async (dispatch, getState) => {
  const isAuthenticated = Boolean(getState().auth);
  const isRacing = data?.sport_id === "7" || data?.sport_id === "4339";


  try {
    let response;

    if (isAuthenticated) {
      if (isRacing) {
        response = await httpAuth.post("/market/allRacingMarkets", data);
      } else {
        response = await httpAuth.post("/sport/getSports");
      }
    } else {
      if (isAuthenticated) {
        return;
      }
      if (isRacing) {
        response = await httpNotAuth.post("/market/allRacingMarketsOpen", data);
      } else {
        response = await httpNotAuth.post("/sport/sports");
      }
    }

    if (response?.data?.status) {
      dispatch(getMenuSuccess(response.data.data));
    } else {
      dispatch(getMenuError());
    }

    return response;
  } catch (error) {
    dispatch(getMenuError());
    return null;
  }
};
